import { render, staticRenderFns } from "./keyboard2.vue?vue&type=template&id=51758647&scoped=true&"
import script from "./keyboard2.vue?vue&type=script&lang=js&"
export * from "./keyboard2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51758647",
  null
  
)

export default component.exports